exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal[data-v-7665f08e]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1;overflow-x:hidden;overflow-y:auto;display:block;background:rgba(0,0,0,.3)}", ""]);

// exports
